export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ: FaqItem[] = [
  {
    question: 'Hoeveel woningen telt Project LEO?',
    answer:
      'Project LEO telt 8 nieuwbouwwoningen in Grobbendonk: 3 eengezinswoningen (vanaf 140 m²) en 5 appartementen (vanaf 102 m²), met 2 tot 4 slaapkamers. De eengezinswoningen hebben een royale buitenruimte, de appartementen ruime terrassen. Het EPC is gunstig.',
  },
  {
    question: 'Wat kost een woning in Project LEO?',
    answer:
      'De prijzen geven we op aanvraag; ze verschillen per woning. Vraag meer informatie en je krijgt de actuele prijzen met beschikbaarheid.',
  },
  {
    question: 'Waar ligt Project LEO precies in Grobbendonk?',
    answer:
      'Project LEO ligt aan de Leopoldstraat 62 in Grobbendonk, tussen de Leopoldstraat en de Floris Primsstraat. Alle voorzieningen liggen binnen handbereik en er is een vlotte verbinding naar Antwerpen en Hasselt.',
  },
  {
    question: 'Voor wie zijn de woningen bedoeld?',
    answer:
      'De 3 eengezinswoningen zijn ontworpen voor gezinnen die ruimte zoeken om te groeien, met een royale buitenruimte. De 5 appartementen zijn er voor wie zorgeloos wil wonen, met gelijkvloers comfort, lifttoegang en ruime terrassen.',
  },
  {
    question: 'Waarom nieuwbouw in plaats van een bestaande woning?',
    answer:
      'Een nieuwbouwwoning voldoet aan de actuele isolatie- en energie-eisen en heeft bij Project LEO een gunstig EPC. Je koopt bovendien met de wettelijke waarborgen die bij nieuwbouw horen, en de eerste jaren staan er geen renovatie- of vervangingsinvesteringen op de planning.',
  },
  {
    question: 'Zijn er garages of parkeerplaatsen?',
    answer:
      'Bij het project zijn garages voorzien. Beschikbaarheid en voorwaarden verschillen per woning; we bezorgen je graag het overzicht.',
  },
  {
    question: 'Is een woning in Project LEO ook een goede investering?',
    answer:
      'Project LEO richt zich zowel op eigen bewoning als op investeerders. Kies in het formulier "Ik wil investeren", dan houden we daar rekening mee in ons antwoord.',
  },
  {
    question: 'Wanneer is Project LEO klaar?',
    answer:
      'De actuele planning en de verwachte oplevering delen we graag persoonlijk. Vraag meer informatie en je ontvangt ze samen met de plannen en de beschikbaarheid.',
  },
  {
    question: 'Wat gebeurt er nadat ik informatie aanvraag?',
    answer:
      'Je krijgt persoonlijk antwoord van het verkoopteam, met de plannen, prijzen en beschikbaarheid die aansluiten bij je vraag. Vrijblijvend, en zonder verkoopdruk.',
  },
];
